@if (loggedIn()) {
  <div id="navigationMenuContact" class="top-navigation-contact" data-cy="navigationMenuContact">
    @if (contactDetails(); as contactDetails) {
      <ds-contact-details [contactDetails]="contactDetails"></ds-contact-details>
    }
  </div>
}
<nav role="navigation" data-cy="navigation">
  <div id="navigationMenu" data-cy="navigationMenu">
    <div class="flex">
      <a
        target="_self"
        tabindex="-1"
        [dsRouterLink]="homeUrl()"
        [attr.title]="headerLogo()?.altText ? headerLogo()?.altText : 'logo'"
      >
        <div
          class="logo-container column text-center fixed-200"
          data-cy="logo"
          tabindex="0"
          [style.backgroundImage]="'url(' + headerLogo()?.logoURL + ')'"
          [style.height.px]="headerLogo()?.height"
          [style.width.px]="headerLogo()?.width"
        ></div>
      </a>
    </div>
    <div role="menubar" id="navigationMenuItems" class="flex" data-cy="navigationMenuItems">
      @for (link of linkArray(); track trackByFn($index)) {
        @if (link.showOnNavigationMenu) {
          <ds-header-navigation-item
            #navItem
            class="link-item"
            [class]="link.linkClasses"
            [link]="link"
            [loaded$]="loaded$()"
            [headerNavRect]="headerNavRect()"
            (linkClickEvent)="linkClicked($event)"
            (sublinkClickEvent)="sublinkClicked($event)"
            (subOpenEvent)="hideAllSubMenus($event)"
          ></ds-header-navigation-item>
        }
      }
      @if (loggedIn() && notifications()) {
        <ds-header-notification
          [headerNavRect]="headerNavRect()"
          [notifications]="notifications()"
          [experienceId]="brandInfo()?.brandState?.experienceId"
        >
        </ds-header-notification>
      }
    </div>
  </div>
</nav>
